import { firestore } from '@psl/functions/firebase/firebaseAccess';
import {
  docDataWithId,
  memorize,
  WithID,
} from '@psl/functions/firebase/rxfireExtensions';
import { ShowEvent } from '@psl/models/ClientModels';
import { shareReplay } from '@psl/utils/rxExtensions';
import { Observable } from 'rxjs';

export const showEvent$ = memorize(
  (eventId: string): Observable<WithID<ShowEvent>> => {
    return docDataWithId(
      firestore().collection('showEvents').doc(eventId),
    ).pipe(shareReplay(1));
  },
);
